import { type ReactNode } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { BarChart3, DollarSign, Users, CreditCard, Bell, ArrowLeft, Search } from 'lucide-react'
import { SeguruSymbol } from '../components/SeguruSymbol'

const NAV_ITEMS = [
  { to: '/admin/overview', label: 'Overview', icon: BarChart3 },
  { to: '/admin/custos', label: 'Custos', icon: DollarSign },
  { to: '/admin/utilizadores', label: 'Utilizadores', icon: Users },
  { to: '/admin/facturacao', label: 'Facturacao', icon: CreditCard },
  { to: '/admin/alertas', label: 'Alertas', icon: Bell },
  { to: '/admin/trace', label: 'Trace', icon: Search },
]

export function AdminShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      {/* Top navigation — D2 invertido (ink scuro com símbolo + texto). */}
      <header
        style={{
          background: 'var(--ink-1)',
          borderBottom: '1px solid rgba(250,250,247,0.08)',
          position: 'sticky',
          top: 0,
          zIndex: 50,
        }}
      >
        <div
          style={{
            maxWidth: '1280px',
            margin: '0 auto',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            height: '56px',
            gap: '24px',
          }}
        >
          {/* Back + brand */}
          <button
            onClick={() => navigate('/chat')}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '4px 0',
            }}
          >
            <ArrowLeft size={16} color="rgba(250,250,247,0.5)" />
            {/* Logo em fundo escuro: ink invertido para branco; ponto
                terracota mantém-se (regra de marca: ponto terracota é
                ADN, nunca trocar de cor). */}
            <SeguruSymbol size={26} ink="#FAFAF7" />
            <span
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: '18px',
                color: '#FAFAF7',
                fontWeight: 400,
                letterSpacing: '-0.01em',
              }}
            >
              seGuru
            </span>
            <span
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                color: 'rgba(250,250,247,0.4)',
                textTransform: 'uppercase',
                letterSpacing: '0.18em',
                marginLeft: '4px',
              }}
            >
              Admin
            </span>
          </button>

          {/* Nav items */}
          <nav style={{ display: 'flex', gap: '4px', marginLeft: '16px' }}>
            {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  fontFamily: 'var(--font-ui)',
                  fontSize: '13px',
                  fontWeight: 500,
                  textDecoration: 'none',
                  color: isActive ? '#FAFAF7' : 'rgba(250,250,247,0.55)',
                  background: isActive ? 'rgba(250,250,247,0.10)' : 'transparent',
                  transition: 'all 0.15s ease',
                })}
              >
                <Icon size={15} />
                <span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Page content */}
      <main
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '24px',
        }}
      >
        {children}
      </main>
    </div>
  )
}
